module.exports = __webpack_public_path__ + "img/l50.a247b75f.png";